<template>
  <div class="upload-cert-container">
    <template v-if="!userData.identityAuth">
      <div class="upload-tips">拍照上传身份证正反面</div>
      <div class="photo-item">

        <!-- <img v-if="previewFront" :src="previewFront" alt="" class="img" />
        <img v-else src="~@/assets/img/cert-front.png" alt="点击拍摄身份证人像面" class="img" />
        <input type="file" class="upload-btn" accept="image/*" @change="selectFront" /> -->

        <Oss @uploadSucess="uploadSuccess" browse_button="uploadFrontBtn" @fileChange="selectedFile"
          :args="{type:'back',key:'frontFile', pathKey:'previewFront',index:0}" :actionFile="frontFile"
          container="frontContainer" :params='frontParams'>
          <div id="frontContainer">
            <span id="uploadFrontBtn" v-if="previewFront">
              <img :src="previewFront" alt="点击拍摄身份证人像面" class="img" />
              <span class="upload-msg">重新上传</span>
            </span>

            <span v-else id="uploadFrontBtn">
              <img src="~@/assets/img/cert-front.png" alt="点击拍摄身份证人像面" class="img" />
              <span class="upload-msg">点击上传身份证人面像</span>
            </span>

          </div>
        </Oss>

      </div>
      <div class="photo-item">
        <Oss @uploadSucess="uploadSuccess" browse_button="uploadpreviewBackBtn" @fileChange="selectedFile"
          :args="{type:'back',key:'previewBackFile',pathKey:'previewBack',index:1}" :actionFile="previewBackFile"
          container="previewBackContainer" :params='previewBackParams'>
          <div id="previewBackContainer">

            <span v-if="previewBack" id="uploadpreviewBackBtn">
              <img :src="previewBack" alt="点击上传手持身份证照片" class="img" />
              <span class="upload-msg">重新上传</span>
            </span>

            <span v-else id="uploadpreviewBackBtn">
              <img src="~@/assets/img/cert-back.png" alt="点击上传手持身份证照片" class="img" />
              <span class="upload-msg">点击上传手持身份证照片</span>
            </span>
          </div>
        </Oss>

      </div>
      <a href="javascript:;" class="commit common-btn"
        :class="{disable:  !(identityPicList && identityPicList.length === 2 && identityPicUrlList && identityPicUrlList.length === 2)}"
        @click="commit">提交认证</a>
    </template>
    <template v-else>
      <div class="process">
        <ul class="process-list">
          <li class="process-item">

            <p class="date">{{userData.identityCommitTime | formatTime}}</p>
            <p class="option">你提交了身份认证信息</p>
            <div class="imgs">
              <img :src="identityPicUrlList[0]" class="img" />
              <img :src="identityPicUrlList[1]" class="img" />
              <img src="~@/assets/img/certed.png" alt="已认证" class="certed" v-if="userData.identityAuth === 3" />
            </div>
          </li>
          <li class="process-item">
            <p class="option" v-if="userData.identityAuth === 1">待后台审核…</p>
            <template v-if="userData.identityAuth === 2">
              <p class="date">{{userData.identityAuthTime | formatTime}}</p>
              <p class="option">后台审核不通过，</p>
              <p class="reason"><span class="strong">不通过原因：</span>{{userData.identityAuthReason}}</p>
            </template>
            <template v-if="userData.identityAuth === 3">
              <p class="date">{{userData.identityAuthTime | formatTime}}</p>
              <p class="option">后台审核通过</p>
            </template>
          </li>
        </ul>
        <a href="javascript:;" class="re-commit common-btn" v-if="userData.identityAuth === 2" @click="reCert">重新认证</a>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { isIOS, transferBytes, watermark } from '@/utils/tools'
import { UPLOAD_TYPE } from '@/config/constant'
import Oss from '@/components/common/oss'

const getRotate = () => {
  return import('@/utils/rotateImg.js')
}

export default {
  name: 'uploadCert',
  components: {
    Oss
  },
  computed: {
    ...mapState({
      userData: 'userData'
    }),
    ...mapGetters({
      userId: 'userId'
    })
  },
  data () {
    return {
      // 0: 未上传; 1: 待审核; 2: 未通过; 3: 通过
      previewFront: null,
      previewBack: null,

      previewFrontId: 0,
      previewBackId: 0,

      identityPicUrlList: [],
      identityPicList: [],

      frontParams: { type: UPLOAD_TYPE.identity },
      previewBackParams: { type: UPLOAD_TYPE.identity },

      frontFile: null,
      previewBackFile: null
    }
  },
  watch: {
    userData (val) {
      if (val) {
        this.identityPicUrlList = this.userData.identityPicUrlList || []
        this.identityPicList = this.userData.identityPicList || []
      }
    }
  },
  methods: {
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),

    // 正面
    uploadSuccess ({ picId, url, args }) {
      // console.log('ssd====>', { picId, url, args })
      let { pathKey, key, index } = args
      this[pathKey] = url
      this[pathKey + 'Id'] = picId
      this[key] = null
      this.identityPicUrlList[index] = url
      this.identityPicList[index] = picId
    },

    selectedFile (e) {
      this[e.args.key] = e.file
    },

    handleImg (file, type, target) {
      if (isIOS()) {
        getRotate().then(({ rotatePhoto }) => {
          rotatePhoto(file, (res) => {
            this.uploadImg(res, type, target)
          })
        })
      } else {
        this.uploadImg(file, type, target)
      }
    },
    uploadImg (file, type, target) {
      this.$root.openLoading()
      // 将文件转换成bytes后上传
      transferBytes(file).then(res => {
        this.$http('/api/member/upload/pic', {
          type: 2,
          pic: res
        }).then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            // 本地预览图片
            let fr = new FileReader()
            fr.onload = (e) => {
              if (type === 0) {
                this.previewFront = e.target.result
              } else {
                this.previewBack = e.target.result
              }
            }
            fr.readAsDataURL(file)

            this.identityPicList[type] = res.data
          } else {
            this.$toast(res.msg)
            target.value = ''
          }
        }, err => {
          this.$root.closeLoading()
          this.$toast(err)
          target.value = ''
        })
      }, err => {
        this.$root.closeLoading()
        this.$toast(err)
        target.value = ''
      })
    },
    // selectFront (e) {
    //   let file = e.target.files[0]
    //   this.handleImg(file, 0, e.target)
    // },
    // selectBack (e) {
    //   let file = e.target.files[0]
    //   this.handleImg(file, 1, e.target)
    // },
    commit () {
      if (this.identityPicList && this.identityPicList.length === 2) {
        this.$root.openLoading()
        // 保存个人信息
        this.$http('/api/member/save', {
          identityPicList: this.identityPicList,
          // 身份证认证状态更改至待审核
          identityAuth: 1
        }).then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            this.updateUserData({
              identityPicList: this.identityPicList,
              identityPicUrlList: this.identityPicUrlList,
              identityAuth: 1,
              identityCommitTime: new Date().getTime()
            })
          } else {
            this.$toast(res.msg)
          }
        }, err => {
          this.$root.closeLoading()
          this.$toast(err)
        })
      }
    },
    reCert () {
      this.updateUserData({
        identityPicList: [],
        identityAuth: 0
      })
    }
  },
  mounted () {
    let { identityPicList, identityPicUrlList } = this.userData
    if (identityPicList && identityPicList.length && identityPicUrlList && identityPicUrlList.length) {
      this.identityPicList = identityPicList
      this.identityPicUrlList = identityPicUrlList
    }
  }
}
</script>
